import { render, staticRenderFns } from "./IssuesViewModal.vue?vue&type=template&id=420bdf72&scoped=true"
import script from "./IssuesViewModal.vue?vue&type=script&lang=js"
export * from "./IssuesViewModal.vue?vue&type=script&lang=js"
import style0 from "./IssuesViewModal.vue?vue&type=style&index=0&id=420bdf72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420bdf72",
  null
  
)

export default component.exports